import { camelCaseToKebabCase } from 'Js/utils/stringUtils';
/**
 * Builds a static HTML id attribute value for testing purposes.
 * Returns `{prefix}-{staticId}` when staticId is non-empty, otherwise undefined.
 */
export function buildStaticId(prefix, staticId, idToKebabCase) {
    if (staticId != null && staticId !== '') {
        let id = staticId;
        if (idToKebabCase) {
            id = camelCaseToKebabCase(staticId);
        }
        return `${prefix}-${id}`;
    }
    return undefined;
}
